import { memo, useCallback, useState } from "react";

import { CalculationSearchFormValues } from "services/api/calculations/types";
import { Button } from "ui/components/Button/Button";
import { TextField } from "ui/components/TextField/TextField";
import { CalculationSearchFilterProps } from "./types";
import { initialCalculationSearchForm } from "services/api/calculations/consts";
import { useHandleDropdownChange } from "services/forms/hooks";
import { transformRoute, useTranslate } from "helpers";
import { Routes as CalculationRoutes } from "ui/modules/calculation/navigation";
import { ButtonLink } from "ui/components/Button/ButtonLink";

const CalculationSearchFilters: React.FC<CalculationSearchFilterProps> = (
  props
) => {
  const { onSearchChange, onCreateClick } = props;

  const { t } = useTranslate();

  const [formValues, setFormValues] = useState<CalculationSearchFormValues>(
    initialCalculationSearchForm
  );

  const handleSearchChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const updatedFormValues = { ...formValues, search: e.target.value };
    setFormValues(updatedFormValues);
    onSearchChange(updatedFormValues);
  };

  const handleResetFormClick = useCallback(() => {
    setFormValues(initialCalculationSearchForm);
  }, []);

  const handleCalculationCreate = useCallback(() => {
    onCreateClick();
  }, [onCreateClick]);

  const handleDropdownChange = useHandleDropdownChange(
    setFormValues,
    formValues
  );

  return (
    <>
      <div className=" ">
        <div className="flex justify-between items-center ">
          <div className="flex flex-wrap gap-3">
            <div className="">
              <TextField
                type="text"
                name="search"
                value={formValues.search}
                onChange={handleSearchChange}
                placeholder={t("admin.search.placeholder")}
                startIcon="../media/icons/search.svg"
                cssClassName="bg-white"
              />
            </div>

            <div className="mr-3 md:mr-6 lg:md-12 flex items-center">
              <span
                onClick={handleResetFormClick}
                className="text-xs font-bold cursor-pointer text-gray-700"
              >
                {t("admin.reset")}
              </span>
            </div>
          </div>
          <div className="py-3 flex gap-2 justify-end ">
            <ButtonLink
              variant="text"
              startIcon="/media/icons/setting.svg"
              to={transformRoute(
                CalculationRoutes.CalculationSettingPageRouter,
                {}
              )}
           
            >
              {t("admin.settings")}
            </ButtonLink>
            <Button
              variant="primary"
              children={t("admin.calculation.search.add")}
              startIcon="/media/icons/plus.svg"
              onClick={handleCalculationCreate}
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default memo(CalculationSearchFilters);
